
import { useEffect, useSyncExternalStore } from 'react';
import { usePathname } from '@/lib/router-compat';

const APP_NAME = 'CRM';

let currentTitle = '';
const listeners = new Set<() => void>();

function setCurrentTitle(t: string) {
  if (currentTitle === t) return;
  currentTitle = t;
  listeners.forEach((l) => l());
}

function subscribe(l: () => void) {
  listeners.add(l);
  return () => {
    listeners.delete(l);
  };
}

function getSnapshot() {
  return currentTitle;
}

// SSR / first client render before any page has reported a title.
function getServerSnapshot() {
  return '';
}

export function usePageTitle(title: string) {
  useEffect(() => {
    const prev = document.title;
    document.title = title ? `${title} — ${APP_NAME}` : APP_NAME;
    setCurrentTitle(title);
    return () => {
      document.title = prev;
    };
  }, [title]);
}

function titleFromPath(pathname: string | null): string {
  if (!pathname) return '';
  const trimmed = pathname.replace(/^\/dashboard\/?/, '').split(/[/?]/)[0];
  if (!trimmed) return 'Dashboard';
  return trimmed
    .split('-')
    .map((s) => s.charAt(0).toUpperCase() + s.slice(1))
    .join(' ');
}

export function useCurrentPageTitle(): string {
  const pathname = usePathname();
  const title = useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
  return title || titleFromPath(pathname);
}
